import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class LeagueListQueryFilter extends QueryFilter {
    organizationId: string;
}

